import { render, staticRenderFns } from "./InspectionHistory.vue?vue&type=template&id=b5822e0a&scoped=true&"
import script from "./InspectionHistory.vue?vue&type=script&lang=ts&"
export * from "./InspectionHistory.vue?vue&type=script&lang=ts&"
import style0 from "./InspectionHistory.vue?vue&type=style&index=0&id=b5822e0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5822e0a",
  null
  
)

export default component.exports